import React from "react";
import { WebService } from "../Services/WebService";
import { TokenContext } from "../TokenContext";
import './CommunityDescription.scss';

interface IState {
    Id?: number,
    Title?: string,
    Description?: string,
    Image64?: string
}

export default class CommunititesWidget extends React.Component<{ id: number }, IState>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;

    componentDidMount(): void {
        new WebService(this.context.token).GetCommunity(this.props.id).then(res => this.setState({ Id: res?.id, Title: res?.title, Description: res?.description, Image64: res?.image64 }));
    }

    render(): React.ReactNode {
        return <div className="community-wrapper">
            {this.state?.Title && <>
                <div className="community-title">{this.state.Title}</div>
                <div className="community-description">{this.state.Description}</div>
                {!!this.state?.Image64 && <div className="community-image-wrapper"><img src={`data:image/jpeg;base64,${this.state?.Image64}`} className="community-image" /></div>}
            </>}
        </div>
    }
}